
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance-glossary",
      function () {
        return require("private-next-pages/finance-glossary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance-glossary"])
      });
    }
  